declare global {
  interface Window {
    catalogAbortController: {
      controller: any;
      signal: any;
    };
  }
}
window.catalogAbortController = {
  controller: undefined,
  signal: undefined,
};

export async function abortCatalogController() {
  if (window.catalogAbortController.controller) {
    window.catalogAbortController.controller.abort();
  }
  const newController = new AbortController();
  window.catalogAbortController.controller = newController;
  window.catalogAbortController.signal = newController.signal;
  return newController.signal;
}
